/**
 * Shared form validators for signup/checkout/password flows.
 * Mirror the rules enforced on the backend (FastAPI server.py).
 *
 * Each function returns:
 *   - ''            (empty string) when valid
 *   - 'Mensagem'    when invalid
 *
 * Pattern is meant to plug directly into `errors[field]` objects and
 * `aria-invalid={!!errors[field]}` styling.
 */

export const cleanPhone = (raw) => (raw || '').replace(/[\s\-()]/g, '');

export const validateName = (name) => {
  const v = (name || '').trim();
  if (!v) return 'Informe seu nome completo.';
  if (v.length < 3) return 'O nome deve ter pelo menos 3 caracteres.';
  if (v.split(/\s+/).length < 2) return 'Informe nome e sobrenome.';
  if (/\d/.test(v)) return 'O nome não pode conter números.';
  if (/[^\w\s\-'À-ÿ]/u.test(v)) return 'O nome contém caracteres inválidos.';
  return '';
};

export const validateEmail = (email) => {
  const v = (email || '').trim().toLowerCase();
  if (!v) return 'Informe seu email.';
  if (!/^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(v)) {
    return 'Email inválido. Use o formato nome@dominio.com';
  }
  return '';
};

export const validateWhatsapp = (raw) => {
  const v = cleanPhone(raw);
  if (!v || v === '+55') return 'Informe seu número de WhatsApp.';
  if (!/^\+\d{10,15}$/.test(v)) {
    return 'Formato inválido. Use: +5511999999999';
  }
  return '';
};

export const validatePassword = (pwd) => {
  if (!pwd) return 'Informe uma senha.';
  if (pwd.length < 8) return 'A senha deve ter no mínimo 8 caracteres.';
  if (!/[A-Za-z]/.test(pwd)) return 'A senha deve conter pelo menos uma letra.';
  if (!/\d/.test(pwd)) return 'A senha deve conter pelo menos um número.';
  return '';
};

export const validateConfirmPassword = (pwd, confirm) => {
  if (!confirm) return 'Confirme sua senha.';
  if (pwd !== confirm) return 'As senhas não conferem.';
  return '';
};
